import { render, staticRenderFns } from "./studyMain.vue?vue&type=template&id=9d559334&scoped=true"
import script from "./studyMain.vue?vue&type=script&lang=js"
export * from "./studyMain.vue?vue&type=script&lang=js"
import style0 from "./studyMain.vue?vue&type=style&index=0&id=9d559334&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d559334",
  null
  
)

export default component.exports